intra_module.controller('UserLoginCtrl', function($scope, User) {
	User.getById({
		id: $scope.user_id
	}).$promise.then(user => $scope.user_display = user.login)
		.catch(() => $scope.user_display = $scope.user_id);
});
